import { gql } from "graphql-tag";

export const SITE_FIELDS = gql`
  fragment SiteFields on Site {
		id
		name
		type
		path
		country_id
		status
		prices_with_tax
		economic_account_id
		currency_id
		send_order_to_warehouse
		warehouse_email
		currency {
			id
			symbol
		}
	}
`;

export default { SITE_FIELDS };
